import React from 'react'
import { ContentSection, InstructionStepper } from '@vwfs-bronson/bronson-react'
import { useTranslation } from 'react-i18next'
import { isAUDI } from '../../../services/common/utils'

interface InstructionComponentProps {
  activeStep: number
  originSystem: string
}

const InstructionComponent = (props: InstructionComponentProps) => {
  const { t } = useTranslation()
  const { activeStep, originSystem } = props
  return (
    <ContentSection.ComponentWrapper>
      <InstructionStepper
        statusActiveText="Status: Erledigt"
        statusNotActiveText="Status: Ausstehend"
      >
        {Object.entries(
          t(`stepper:${originSystem}:steps`, {
            returnObjects: true,
            defaultValue: t('stepper:default:steps', { returnObjects: true }),
          })
        )?.map(([key, value]: any, index) => (
          <InstructionStepper.Step
            key={key}
            state={index < activeStep ? 'is-active' : undefined}
            icon={value?.icon}
            title={
              isAUDI({ salesChannel: { originSystem } })
                ? ((<b>{value?.title}</b>) as unknown as string)
                : value?.title
            }
            {...(index === activeStep - 1 ? { 'aria-current': 'step' } : {})}
          >
            {value?.text}
          </InstructionStepper.Step>
        ))}
      </InstructionStepper>
    </ContentSection.ComponentWrapper>
  )
}

export default InstructionComponent
